import { UiSchema } from '@rjsf/utils'

export function getUiSchema(): UiSchema {
  return {
    type: { 'ui:widget': 'radio', 'ui:classNames': 'create-bot-name-bot-type' }
  }
}
